module.exports = __webpack_public_path__ + "img/iconos.30eb45d6.png";